
import SectionDivisor from "./SectionDivisor.vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { computed, ComputedRef, defineComponent, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { Course } from "../../../../domain/entities/entities";
import Card from "./Card.vue";
import { dispatchError } from "../../utils/error_handling";
import { wrapLoading } from "../../utils/wrap_loading";

export default defineComponent({
  components: {
    Carousel,
    Slide,
    Navigation,
    Card,
    SectionDivisor
  },
  setup() {
    const store = useStore();

    onBeforeMount(async () => {
      await loadNewsCourses();
    });

    const newsCourses: ComputedRef<Course[]> = computed(() => {
      return store.getters["course_module/newCourses"] || [];
    });

    const settings = {
      itemsToShow: 1,
      transition: 1000
    };

    const breakpoints = {
      0: {
        itemsToShow: 1,
        snapAlign: "center"
      },

      280: {
        itemsToShow: 1,
        snapAlign: "center"
      },

      520: {
        itemsToShow: 2,
        snapAlign: "center",
        itemsToScroll: 2
      },

      980: {
        itemsToShow: 3,
        snapAlign: "center",
        itemsToScroll: 3
      },

      1030: {
        itemsToShow: 3,
        snapAlign: "center",
        itemsToScroll: 3
      },

      1580: {
        itemsToShow: 4,
        snapAlign: "center",
        itemsToScroll: 4
      }
    };

    function formattedDuration(duration: number) {
      const sec = duration;
      let hours: string | number = Math.floor(sec / 3600);
      let minutes: string | number = Math.floor((sec - hours * 3600) / 60);
      let seconds: string | number = sec - hours * 3600 - minutes * 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (hours > 24) {
        return hours + "h";
      }
      if (hours == 0) {
        return minutes + ":" + seconds + "m";
      }
      return hours + ":" + minutes + ":" + seconds + "h";
    }

    async function loadNewsCourses(): Promise<void> {
      try {
        await wrapLoading(async () => {
          await store.dispatch("course_module/loadNewsCourses");
        });
      } catch (e) {
        await dispatchError(e);
      }
    }
    return {
      newsCourses,
      breakpoints,
      settings,
      formattedDuration
    };
  }
});
